import { getExecutionSummary, getIntentNarrative, truncateNarrative } from '@/copy/workoutNarratives';
import type { CalendarSession } from '@/lib/api';
import type { CompletedActivity } from '@/types';
import type { CalendarItem } from '@/types/calendar';

export function deriveCalendarItemIntentText(item: CalendarItem): string | undefined {
  const isCompleted = item.kind === 'completed';
  const narrative = getIntentNarrative(item.sport, item.intent, isCompleted);
  return truncateNarrative(narrative);
}

export function deriveCalendarItemExecutionSummary(item: CalendarItem): string | undefined {
  if (item.kind !== 'completed') {
    return undefined;
  }

  if (item.executionNotes && item.executionNotes.trim()) {
    return truncateNarrative(item.executionNotes.trim());
  }

  if (!item.compliance) {
    return undefined;
  }

  const summary = getExecutionSummary(item.compliance, {
    isPaired: item.isPaired,
  });
  return truncateNarrative(summary);
}

export function deriveWorkoutIntentText(
  session?: CalendarSession | null,
  item?: CalendarItem | null,
): string | undefined {
  if (item?.description) return item.description;
  if (session?.notes) return session.notes;
  if (item) return deriveCalendarItemIntentText(item);
  return undefined;
}

export function deriveWorkoutExecutionSummary(
  item?: CalendarItem | null,
  activity?: CompletedActivity | null,
): string | undefined {
  if (item?.executionNotes) return item.executionNotes;
  if (item?.compliance === 'complete') return 'On target — matched plan.';
  if (item?.compliance === 'partial') return 'Completed with reduced volume.';
  if (item?.compliance === 'missed') return 'Missed due to schedule or fatigue.';
  if (item) return deriveCalendarItemExecutionSummary(item);
  if (activity?.coachFeedback) return activity.coachFeedback;
  return undefined;
}
